


































import { DataTableAction, JobListingPlanConfiguration } from '@/utils/types'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Action, Getter } from 'vuex-class'
import DataTable from '../../components/DataTable.vue'
import { DataTableHeader } from 'vuetify'
import JobListingPlanConfigurationCrud from '../../components/JobListingPlanConfigurationCrud.vue'

@Component({
  components: { DataTable, JobListingPlanConfigurationCrud }
})
export default class Configurations extends Vue {
  @Action fetchJobListingPlanConfigurations!: () => Promise<void>;

  @Action upsertJobListingPlanConfiguration!: (
    payload: JobListingPlanConfiguration
  ) => Promise<boolean>;

  @Getter jobListingPlanConfigurations!: JobListingPlanConfiguration[]

  isDialogOpen = false;
  selectedConfiguration: JobListingPlanConfiguration | null = null
  configurationHeaders: DataTableHeader[] = [
    { text: 'מסלול פרסום', value: 'title' },
    { text: 'עלות', value: 'price' }];

  async mounted () {
    await this.fetchJobListingPlanConfigurations()
  }

  get jobPlanConfigurationActions (): DataTableAction<JobListingPlanConfiguration>[] {
    return [
      {
        text: 'עריכה',
        icon: 'mdi-pencil',
        handler: (jobListingPlanConfiguration) => this.openCrudDialog(jobListingPlanConfiguration)
      }
    ]
  }

  get formattedJobListingPlanConfigurations () {
    return this.jobListingPlanConfigurations.map((conf) => ({
      key: conf.id,
      title: conf.title,
      applicationAmount: conf.applicationAmount,
      description: conf.description,
      features: conf.features,
      featuresTitle: conf.featuresTitle,
      plan: conf.plan,
      price: conf.price,
      publishButton: conf.publishButton,
      publishDuration: conf.publishDuration
    })
    )
  }

  async handleSubmit (jobListingPlanConfiguration: JobListingPlanConfiguration) {
    await this.upsertJobListingPlanConfiguration(jobListingPlanConfiguration)
    this.closeCrudDialog()
  }

  openCrudDialog (jobListingPlanConfiguration: JobListingPlanConfiguration | null = null) {
    this.selectedConfiguration = jobListingPlanConfiguration
    this.isDialogOpen = true
  }

  closeCrudDialog () {
    this.isDialogOpen = false
    this.selectedConfiguration = null
  }
}
